import Header from "./components/Header/Header";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div>
      <Header />
      <Home />
      <Services />
      <Footer />
    </div>
  );
}

export default App;
